/**
 * Base collection
 * 
 * @class BaseCollection
 */

BaseCollection = (function (Collection) {

	var BaseCollection = function () {
		this.construct.apply(this, arguments);
	};

	$.extend(true, BaseCollection.prototype, Collection.prototype, {

		/**
		 * Initialize
		 * @param {Object} config - config parameters
		 * @param {Boolean} config.endless - indicate endless collection (circular collection)
		 */
		init: function(config) {
			config = config || {};
			this.config.endless = config.endless || this.config.endless || false;
		},

		/**
		 * To get items from collection
		 * @param {Number} index - start index (optional). if not specified, it returns all items
		 * @param {Number} length - number of required items. (optional)
		 * @returns {Array.Model} array of models
		 */
		getItems: function(index, length) {
			if(typeof(index) === "undefined") {
				return this.models || [];
			} else {
				index = index || 0;
				length = length || this.models.length;
				
				// collection in endless mode
				if(this.config.endless) {
					this.leftIdx = this.getCircleIndex(index);
					this.rightIdx = this.getCircleIndex(index + length -1);
				// collection in normal mode
				} else {
					if(index >= this.models.length || index < 0) { return []; }
					this.leftIdx = index;
					this.rightIdx = this.getFixIndex(index + length - 1);
				}
				
				return this.getNextItems(this.leftIdx, length);
			}
		},

		/**
		 * @returns {Model}
		 */
		getById: function(id) {
			for(var i = 0; i < this.models.length; i++) {
				if(this.models[i].getId() == id) {
					return this.models[i];
				}
			}
			return false;
		},

		getNext: function(count) {
			count = count || 1;
			var arr = this.getNextItems(this.rightIdx +1, count);
			// update indexes
			this.rightIdx = this.rightIdx + arr.length;
			this.leftIdx = this.leftIdx + arr.length;
			if(this.config.endless) {
				this.rightIdx = this.getCircleIndex(this.rightIdx);
				this.leftIdx = this.getCircleIndex(this.leftIdx);
			}
			return arr;
		},

		getPrev: function(count) {
			count = count || 1;
			var arr = this.getPrevItems(this.leftIdx -1, count);
			// update indexes
			this.rightIdx = this.rightIdx - arr.length;
			this.leftIdx = this.leftIdx - arr.length;
			if(this.config.endless) {
				this.rightIdx = this.getCircleIndex(this.rightIdx);
				this.leftIdx = this.getCircleIndex(this.leftIdx);
			}
			return arr;
		},

		getNextItems: function(index, length) {
			var arr = [], idx;
			var items = this.getItems();
			if(items.length == 0) { return []; }
			
			for(var i = 0; i < length; i++) {
				idx = index + i;
				if(this.config.endless) {
					idx = this.getCircleIndex(idx, items.length);   // circle
				}
				if(idx >= items.length) { break; }
				arr.push(items[idx]);
			}
			return arr;
		},

		getPrevItems: function(index, length) {
			var arr = [], idx;
			var items = this.getItems();
			if(items.length == 0) { return []; }
			
			for(var i = 0; i < length; i++) {
				idx = index - i;
				if(this.config.endless) {
					idx = this.getCircleIndex(idx, items.length);   // circle
				}
				if(idx < 0) { break; }
				arr.push(items[idx]);
			}
			return arr;
		},

		getCircleIndex: function(index, length) {
			index = index || 0;
			length = length || this.getItems().length || 0;
			
			index = index % length;                     // circle
			index = index < 0 ? length + index : index; // negative index convert to positive
			
			return index;
		},

		getFixIndex: function(index, length) {
			index = index || 0;
			length = length || this.getItems().length || 0;
			
			if(index > length -1) { index = length -1; }
			if(index < 0) { index = 0; }
			
			return index;
		},

		/**
		 * Get total results (availabe after 1st call of API)
		 * @returns {Number}
		 */
		getTotalCount: function() {
			try {
				return this._meta.total;
			} catch (e) {
				return this.length;
			}
		}

	});

	return BaseCollection;

})(Collection);



//////////////////
// WEBPACK FOOTER
// ./js/collection/base_collection.js
// module id = 4
// module chunks = 0